import actionTypes from '../actions/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_SENT_MESSAGES_LIST_SUCCESS: {
      return [...action.messages];
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/message/reducers/sent.js